<template>
  <div>
    <div v-if="reportData == null && !reportFlag">
      <v-sheet outlined>
        <v-data-table
          :headers="headers"
          disable-pagination
          :items="items"
          tableClasses="item-table border"
          responsive
          hide-default-footer
          fixed-header
          ref="baseTable"
          :single-select="true"
          show-select
          v-model="selected"
          checkbox-color="primary"
          :item-class="itemRowBackground"
        >
          <template v-slot:[`item.createdTimeUtc`]="{ item }">
            {{ item.createdTimeUtc | moment }}
          </template>
          <template v-slot:[`item.responseStatus`]="{ item }">
            {{ responseStatusDisplayName(item.responseStatus) }}
            {{
              item.status == 'Reject' && item.responseStatus == 0
                ? '(شرکت نمیکنم)'
                : item.status == 'Accept' && item.responseStatus == 0
                ? '(شرکت میکنم)'
                : ''
            }}
          </template>
          <template v-slot:[`item.result`]="{ item }">
            {{
              item.responseStatus == 'Sent' ||
              item.responseStatus == 'Viewed' ||
              item.responseStatus == 'Reviewed' ||
              item.responseStatus == 'Selected'
                ? 'درحال بررسی'
                : item.responseStatus == 'Rejected'
                ? 'برنده نشده'
                : ''
            }}
            <v-btn
              color="primary"
              small
              v-if="item.responseStatus == 'Won'"
              @click="getResponsesAbstract(item)"
            >
              <v-icon left color="yellow"> mdi-check-all </v-icon>
              {{
               item.request == 'DirectOrder' 
                  ? 'قبول پیشنهاد '
                  : item.request != 'ContractorRecognition'? 'برنده شده' : 'برگزیده'
              }}
            </v-btn>
          </template>
          <template v-slot:[`item.operations`]="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  link
                  color="primary"
                  v-if="item.tradeResponseId == null"
                  @click="showDetail(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>مشاهده جزئیات</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  color="primary"
                  v-if="item.hasResponse && item.responseStatus == 'Draft'"
                  @click="viewReport(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-send</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> بررسی جهت ارسال </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  color="primary"
                  @click="navToEdit(item)"
                  v-if="item.tradeResponseId != null"
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        item.responseStatus == 'Draft' ||
                        item.responseStatus == 'Sent'
                          ? 'ویرایش پاسخ'
                          : 'مشاهده پاسخ'
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  color="primary"
                  @click="remove(item)"
                  v-if="
                    item.tradeResponseId != null &&
                    (item.responseStatus == 'Draft' ||
                      item.responseStatus == 'Sent')
                  "
                >
                  <v-list-item-icon>
                    <v-icon color="error" small>mdi-trash-can</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>حذف پاسخ</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  color="primary"
                  @click="rejectMerchantNotification(item)"
                  v-if="
                    item.responseStatus == 0 &&
                    item.status != 'Reject' &&
                    item.responseStatus != 'Draft' &&
                    item.responseStatus != 'Sent' &&
                    item.responseStatus != 'Viewed' &&
                    item.responseStatus != 'Reviewed' 
                   
                  "
                >
                  <v-list-item-icon>
                    <v-icon color="error" small>mdi-close</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> {{ item.request == 'DirectOrder' ? 'پاسخ نمی‌دهم' : 'رد درخواست' }} </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  color="primary"
                  @click="acceptMerchantNotification(item)"
                  v-if="
                    item.responseStatus == 0 &&
                    item.status != 'Accept' &&
                    item.responseStatus != 'Draft' &&
                    item.responseStatus != 'Sent' &&
                    item.responseStatus != 'Viewed' &&
                    item.responseStatus != 'Reviewed' 
                    
                  "
                >
                  <v-list-item-icon>
                    <v-icon color="primary" small>mdi-check-decagram</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> {{ item.request == 'DirectOrder' ? 'پاسخ می‌دهم' : 'پذیرش درخواست' }} </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-sheet>
      <v-dialog
        width="700px"
        v-model="showDocumentsModal"
        v-if="showDocumentsModal"
      >
        <v-card
          class="pa-5"
          v-if="decumentNeedApprovel && decumentNeedApprovel.length"
        >
          <v-card-text>
            <v-col cols="12">
              <h6 class="blue--text mb-3">فایل اطلاعات پیوست</h6>
            </v-col>
            <v-row>
              <v-col
                cols="6"
                md="4"
                v-for="(x, i) in decumentNeedApprovel"
                :key="i"
              >
                <v-card>
                  <v-card-text>
                    <v-col cols="12">
                      <v-img
                        v-if="x.fileId && x.fileId.thumbnailFileUrl"
                        :src="x.fileId.thumbnailFileUrl"
                        width="80%"
                      />
                    </v-col>
                    <v-col cols="12">
                      <label> نوع فایل:</label>
                      <strong>{{ x.documentTypeTitle }}</strong>
                    </v-col>
                    <v-col cols="12">
                      <label> توضیحات:</label>
                      <strong>{{
                        x.description ? x.description : 'وارد نشده'
                      }}</strong>
                    </v-col>
                    <v-col cols="12">
                      <a
                        target="_blank"
                        :href="
                          x.fileId && x.fileId.fileUrl ? x.fileId.fileUrl : ''
                        "
                        >{{ x.fileId && x.fileId.fileUrl ? 'دانلود' : '' }}</a
                      >
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-checkbox
              v-model="documentApprovalcheckbox"
              label="
                کلیه  مدارک  را مطالعه کردم و مورد تائید است
          "
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="documnetsReviewedFunc"
              :disabled="!documentApprovalcheckbox"
              >تایید و پاسخ</v-btn
            >
            <v-btn
              color="error"
              @click="
                showDocumentsModal = false;
                decumentNeedApprovel = null;
              "
              >بستن</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="resultModal" v-if="resultModal" width="700px">
        <v-card>
          <v-card-title>نتایج شرکت در مناقصه</v-card-title>
          <v-card-text>
            <v-sheet outlined>
              <v-data-table
                :items="resultItems"
                :headers="resultHeaders"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:[`item.finalizeForm`]="{ item }">
                  <v-btn
                    color="primary"
                    small
                    v-if="item.itemStatus == 'Won'"
                    @click="navToFinalize(item)"
                    >مشاهده ابلاغ</v-btn
                  >
                </template>
                <template v-slot:[`item.totalAmount`]="{ item }">
                  {{ item.totalAmount }}
                  {{ item.measurementUnitTitle }}
                </template>
                <template v-slot:[`item.committedAmount`]="{ item }">
                  {{ item.totalAmount }}
                  {{ item.measurementUnitTitle }}
                </template>
                <template v-slot:[`item.price`]="{ item }">
                  {{ item.price.amount }}
                  {{ item.price.title }}
                </template>
                <template v-slot:[`item.itemStatus`]="{ item }">
                  {{ itemStatusDisplayName(item.itemStatus) }}
                </template>
              </v-data-table>
            </v-sheet>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error"
              small
              @click="
                resultModal = false;
                resultItems = [];
              "
              >بستن</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="text-center pt-5">
        <v-row>
          <v-col cols="12" sm="2" md="2">
            <v-select
              outlined
              dense
              v-model="itemsPerPage"
              :items="[5, 10, 20]"
              label="تعداد نمایش در صفحه"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="10" md="10">
            <v-pagination
              circle
              v-model="pageNumber"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-else>
      <TradeResponseReport
        @reportFlag="
          reportFlag = false;
          reportData = null;
        "
        @getData="getTradeRequestMerchantNotificationsBySupplier"
        :propData="reportData"
      >
      </TradeResponseReport>
    </div>
  </div>
</template>

<script>
const tradeResponseRepository = () => RepoFactory.get('tradeResponse');
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
import TradeResponseReport from './TradeResponseReport.vue';

import qs from 'qs';
const tradeRequestRepository = () => RepoFactory.get('tradeRequests');
const enumsRepository = () => RepoFactory.get('enums');
export default {
  components: {
    TradeResponseReport,
  },
  data() {
    return {
      selectedItem: null,
      reportFlag: false,
      reportData: null,
      resultModal: false,
      resultHeaders: [
        {
          value: 'tradeRequestItemTitle',
          text: ' موضوع ',
          sortable: true,
        },
        {
          value: 'totalAmount',
          text: 'تعداد کل ',
          sortable: true,
        },

        {
          value: 'committedAmount',
          text: 'تعداد تخصیص یافته ',
          sortable: true,
        },
        {
          value: 'price',
          text: 'قیمت',
          sortable: true,
        },
        {
          value: 'itemStatus',
          text: 'وضعیت',
          sortable: true,
        },
        {
          value: 'finalizeForm',
          text: 'وضعیت',
          sortable: true,
        },
      ],
      resultItems: [],
      responseStatusList: [],
      selected: [],
      selectedTrade: null,
      documentApprovalcheckbox: false,
      showDocumentsModal: false,
      headers: [
        {
          value: 'tradeRequestNumber',
          text: 'شماره درخواست ',
          sortable: true,
        },
        { text: 'تاریخ سفارش', value: 'createdTimeUtc' },
        {
          value: 'itemsCount',
          text: 'تعداد اقلام ',
          sortable: true,
        },
        {
          value: 'requestDisplayName',
          text: 'موضوع درخواست',
          sortable: true,
        },
        {
          value: 'categoryDisplayName',
          text: 'نوع درخواست',
          sortable: true,
        },
        {
          value: 'bidExpirationTimeInDaysFromNow',
          text: 'زمان باقی مانده',
          sortable: true,
        },
        {
          value: 'merchantName',
          text: 'سفارش دهنده',
          sortable: true,
        },
        {
          value: 'responseStatus',
          text: 'وضعیت',
          sortable: true,
        },
        {
          value: 'result',
          text: 'نتیجه',
          sortable: true,
        },
        {
          value: 'operations',
          text: 'عملیات',
          sortable: true,
        },
      ],
      itemStatusList: [],
      itemsPerPage: 10,
      pageNumber: 1,
      // pageCount: 0,
      items: [],
      decumentNeedApprovel: null,
    };
  },
  computed: {
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    pageCount() {
      if (this.items && this.items.length && this.itemsPerPage > 0) {
        return Math.ceil(
          this.$store.getters.tradeResponseCurrentList.totalCount /
            this.itemsPerPage
        );
      }
    },
  },
  created() {
    if (
      this.$store.getters.tradeResponsePageNumber != null &&
      this.$store.getters.tradeResponseItemsPerPage != null
    ) {
      this.pageNumber = this.$store.getters.tradeResponsePageNumber;
      this.itemsPerPage = this.$store.getters.tradeResponseItemsPerPage;
    } else {
      this.pageNumber = 1;
      this.itemsPerPage = 10;
    }
    if (this.$store.getters.tradeResponseSelectedItem != null) {
      this.selected = [];
      this.selected.push(this.$store.getters.tradeResponseSelectedItem);
    }
    if (this.merchantId) {
      this.getTradeRequestMerchantNotificationsBySupplier();
    }
    this.itemStatus();
    this.responseStatus();
  },
  watch: {
    merchantId() {
      this.getTradeRequestMerchantNotificationsBySupplier();
    },
    pageNumber(after, before) {
      if (after) {
        this.getTradeRequestMerchantNotificationsBySupplier();
        this.$store.commit('setTradeResponsePageNumber', after);
        this.$store.commit('setTradeResponseItemsPerPage', this.itemsPerPage);
      }
    },
    itemsPerPage(after, before) {
      this.$store.commit('setTradeResponsePageNumber', 1);
      this.pageNumber = 1;
      if (after) {
        this.getTradeRequestMerchantNotificationsBySupplier();
        this.$store.commit('setTradeResponseItemsPerPage', after);
      }
    },
  },

  methods: {
    itemRowBackground: function (item) {
      return item.request == 'DirectOrder' ? 'style-1' : 'style-2';
    },
    itemStatusDisplayName(title) {
      if (this.itemStatusList.length) {
        let result = this.itemStatusList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    itemStatus() {
      enumsRepository()
        .getEnum('TradeResponseItemStatus', this.tradeBaseUrl)
        .then((res) => {
          this.itemStatusList = res.data;
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
    responseStatusDisplayName(title) {
      if (this.responseStatusList.length) {
        let result = this.responseStatusList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    responseStatus() {
      // this.responseStatusList = this.getEnumByTitle('TradeResponseStatus');
      enumsRepository()
        .getEnum('TradeResponseStatus', this.tradeBaseUrl)
        .then((res) => {
          this.responseStatusList = res.data;
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
    navToEdit(item) {
      this.selected = [];
      const loader = this.$loading.show();
      tradeResponseRepository()
        .getTradeResponseById(item.tradeResponseId, this.tradeBaseUrl, {
          MerchantId: this.merchantId,
        })
        .then((res) => {
          this.$store.commit('setTradeResponseProp', item);

          this.$store.commit('setTradeResponseSelectedItem', item);
          this.$store.commit('setTradeResponseHasResponse', item.hasResponse);
          this.$store.commit('setTradeResponseMerchantNotificationId', item.id);
          this.$store.commit('setTradeResponseId', item.tradeResponseId);
          this.$store.commit('setTradeResponseSelectedForEdit', res.data);
          this.$store.commit('setTradeResponseIsEdit', true);
          this.$store.commit('setTradeResponseShowForm', true);
          this.$router.push({
            path: `/trade-response-info/${item.tradeRequestId}`,
          });
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    getTradeRequestMerchantNotificationsBySupplier() {
      if (this.merchantId) {
        let params = {
          PageNumber: this.pageNumber,
          ItemsPerPage: this.itemsPerPage,
          Orders: [
            {
              column: 'createdTimeUtc',
              order: 'Descending',
            },
          ],
        };

        const loader = this.$loading.show();
        tradeResponseRepository()
          .getTradeRequestMerchantNotificationsBySupplier(
            this.tradeBaseUrl,
            { MerchantId: this.merchantId },
            params,
            (params) => {
              return qs.stringify(params, { allowDots: true });
            }
          )
          .then((res) => {
            if (res.data.list != null) {
              this.items = res.data.list;
              this.$store.commit('setTradeResponseCurrentList', res.data);
            } else {
              this.items = [];
              this.$store.commit('setTradeResponseCurrentList', res.data);
            }
            loader.hide();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            loader.hide();
          });
      }
    },
    showDetail(item) {     
      this.$store.commit('setTradeResponseProp', item);

      this.$store.commit('setTradeResponseSelectedItem', item);
      this.selected = [];
      this.selectedTrade = item;
      this.$store.commit('setTradeResponseMerchantNotificationId', item.id);
      this.$store.commit('setTradeResponseHasResponse', item.hasResponse);
      this.$store.commit('setTradeResponseIsEdit', false);
      this.$store.commit('setTradeResponseShowForm', true);
      this.$router.push({
        path: `/trade-response-info/${item.tradeRequestId}`,
      });
    },
    viewReport(item) {
      this.$store.commit('setTradeResponseProp', item);
      this.$store.commit('setTradeResponseSelectedItem', item);
      this.selected = [item];
      this.reportData = item;
      this.reportFlag = true;
    },
    sendResponse(item) {
      this.selected = [];
      this.selected.push(item);
      const loader = this.$loading.show();
      tradeResponseRepository()
        .submitResponse(item.tradeResponseId, this.tradeBaseUrl, {
          MerchantId: this.merchantId,
        })
        .then((res) => {
          this.$dialog.message.success(' با موفقیت ارسال شد. ', {
            position: 'top-left',
          });
          this.getTradeRequestMerchantNotificationsBySupplier();
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    acceptMerchantNotification(item) {
      this.selected = [];
      this.selected.push(item);
      const loader = this.$loading.show();
      tradeResponseRepository()
        .tradeRequestMerchantNotificationAccept(
          item.id,
          { tradeRequestId: item.tradeRequestId },
          this.tradeBaseUrl,
          { MerchantId: this.merchantId }
        )
        .then((res) => {
          this.$dialog.message.success(' با موفقیت ثبت شد. ', {
            position: 'top-left',
          });
          this.getTradeRequestMerchantNotificationsBySupplier();
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    rejectMerchantNotification(item) {
      this.selected = [];
      this.selected.push(item);
      const loader = this.$loading.show();
      tradeResponseRepository()
        .tradeRequestMerchantNotificationReject(
          item.id,
          { tradeRequestId: item.tradeRequestId },
          this.tradeBaseUrl,
          { MerchantId: this.merchantId }
        )
        .then((res) => {
          this.$dialog.message.success(' با موفقیت ثبت شد. ', {
            position: 'top-left',
          });
          this.getTradeRequestMerchantNotificationsBySupplier();
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    openResponseForm(item) {
      this.$store.commit('setTradeResponseSelectedItem', item);
      this.selected = [];
      this.$router.push({
        path: `/trade-response-form/${item.tradeRequestId}`,
      });
    },
    getResponsesAbstract(item) {
      this.selectedItem = item;
      this.selected = [item];
      const loader = this.$loading.show();
      tradeResponseRepository()
        .tradeRequestAbstractBySupplier(
          this.tradeBaseUrl,
          { MerchantId: this.merchantId },
          { tradeRequestId: item.tradeRequestId }
        )
        .then((res) => {
          this.resultModal = true;

          this.resultItems = res.data;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    navToFinalize(item) {
      this.$store.commit('setTradeResponseSelectedItem', this.selectedItem);
      this.selected = [];
      const loader = this.$loading.show();
      Promise.all([
        this.getTradeRequestById(item),
        this.getTradeResponseItemsByTradeRequestId(item),
      ])
        .then(() => {})
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    getTradeRequestById(item) {
      tradeRequestRepository()
        .getTradeRequestById(item.tradeRequestId, this.tradeBaseUrl)
        .then((res) => {
          this.$store.commit('setTradeRequestSelectedForDisplay', res.data);
          let tradeItem = res.data.items.filter((tradeItem) => {
            return tradeItem.id == item.tradeRequestItemId;
          });
          this.$store.commit('setTradeRequestResponsesHeader', tradeItem[0]);
          this.$store.commit('setTradeRequestSelectedToFinalize', item);
          tradeResponseRepository()
            .viewAssigned(
              item.tradeResponseId,
              { tradeResponseItemId: item.tradeResponseItemId },
              this.tradeBaseUrl,
              { MerchantId: this.merchantId }
            )
            .then()
            .catch((err) => {
              Helper.handleErrors(err, this);
            });
          this.$router.push({ path: `/trade-request-finalize` });
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    getTradeResponseItemsByTradeRequestId(item) {
      //   let params={
      //     tradeRequestItemId :item.tradeRequestItemId,
      //     pageNumber : 1,
      //     itemsPerPage :500,
      //   }
      //   tradeRequestResponseRepository()
      //   .getAllResponsesPerItem(this.tradeBaseUrl, {MerchantId:this.$store.getters.tradeRequestSelectedForDisplay.merchantId}, params)
      //   .then((res)=>{
      //     let response = null
      //     if(res.data.list){
      //       response = res.data.list.filter(resItem=>{
      //         return resItem.tradeResponseItemId == item.tradeResponseItemId
      //       })
      //       this.$store.commit('setTradeRequestSelectedToFinalize', response)
      //       this.$router.push({path:`/trade-request-finalize`})
      //   }
      //   })
      //   .catch((err) => {
      //       Helper.handleErrors(err, this);
      //     })
    },
  },
};
</script>

<style>
.style-1 {
  background-color: rgb(209, 239, 245);
}
.style-2 {
  background-color: rgb(255, 255, 254);
}
</style>
